<div class="loginPage">
  <div class="login-wrapper">
    <form (ngSubmit)="onSubmit()" #form="ngForm">
      <div class="container">
        <div class="form">
          <div class="portalLogo"></div>
          <div class="text-center">
            <h2>Log In</h2>
          </div>
          <div *ngIf="isLoginError" class="error_mess">
            <p>Invalid Username or Password.</p>
          </div>
          <div class="form-group">
            <input
              class="form-input"
              name="email"
              type="email"
              id="login-input"
              placeholder="Email address"
              [(ngModel)]="email"
              #emailInput="ngModel"
              required
            />
            <label for="login-input" class="form_label">Email address</label>
            <div *ngIf="form.submitted && emailInput.invalid" class="alert alert-danger">
              <span>Please enter valid email</span>
            </div>
          </div>
          <div class="form-group">
            <input
              class="form-input"
              name="password"
              type="password"
              id="password-input"
              placeholder="Password"
              [(ngModel)]="password"
              #passwordInput="ngModel"
              minlength="6"
              required
            />
            <label for="password-input" class="form_label">Password</label>
            <div *ngIf="form.submitted && passwordInput.invalid" class="alert alert-danger">
              <span>Please enter password</span>
            </div>
          </div>
          <div class="row mt-3">
            <div
              class="forgot"
              [ngClass]="{ 'col-md-12': isSubmit, 'col-md-8': !isSubmit }"
            >
              <a [routerLink]="['/forgot-password']">Forgot your password?</a>
            </div>
            <div class="col-md-4" *ngIf="!isSubmit">
              <button type="submit" class="primary-button" id="login-button">
                Log In
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="footer">
      <a
        href="https://www.marshmma.com/us/privacy-notice.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Notice
      </a>
    </div>
  </div>
</div>
